import React from "react";

const Button = ({
    loading,
    type,
    color,
    icon,
    children,
    savingText,
    classes = ""
}) => {
    if (loading) {
        return (
            <button
                type={type ? type : "button"}
                className={`btn btn-${color ? color : "primary"} ${classes}`}
                disabled
            >
                {savingText ? savingText : "Saving"}{" "}
                <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                ></span>
            </button>
        );
    }

    return (
        <button
            type={type ? type : "button"}
            className={`btn btn-${color ? color : "primary"} ${classes}`}
        >
            {children} {icon && <i className={icon}></i>}
        </button>
    );
};

export default Button;
